export default __webpack_public_path__ + "0105506999e4262b63e686cbd1ddc6e2.svg";